import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/HomeNavBar/HomeNavBar.vue';
import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import { view_profile as view_profile_helper } from "@/views/Feed/feed_helper.js";

export default {
  components: {
    Sidebar,
    Navbar,
    InactivityModal
  },
  data() {
    return ({
      isLoading: false,
      businesses: [],
      business_dashboard_filter: 'all',
      user_details: {
        user_role: '',
      },
    });
  },
  computed: {
    filtered_businesses() {
      return this.get_filtered_businesses(this.businesses);
    },
    business_dashboard_cards() {
      return [
        { label: 'Total businesses', value: this.businesses.length, icon: 'bi-buildings-fill', tone: 'primary', filter: 'all' },
        { label: 'Business owners', value: this.business_owner_count, icon: 'bi-person-badge-fill', tone: 'success', filter: 'owners' },
        { label: 'With email', value: this.businesses_with_email_count, icon: 'bi-envelope-fill', tone: 'info', filter: 'email' },
        { label: 'With phone', value: this.businesses_with_phone_count, icon: 'bi-telephone-fill', tone: 'secondary', filter: 'phone' },
      ];
    },
    business_owner_count() {
      return new Set(this.businesses.map(business => this.get_business_owner_id(business)).filter(Boolean)).size;
    },
    businesses_with_email_count() {
      return this.businesses.filter(business => this.has_business_email(business)).length;
    },
    businesses_with_phone_count() {
      return this.businesses.filter(business => this.has_business_phone(business)).length;
    },
  },

  methods: {

    is_enabled_feature(value) {
      return value === true || value === 'true' || value === 1 || value === '1';
    },
    getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
     initDataTable(id) {
      const table = $(id)

      if (!table.length) return

      // Destroy if already initialised
      if ($.fn.DataTable.isDataTable(id)) {
        table.DataTable().destroy()
      }

      table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 10,
        language: {
          paginate: {
            previous: "Previous",
            next: "Next"
          },
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "No entries available"
        }
      })
    },
    refresh_business_table() {
      this.$nextTick(() => {
        this.initDataTable('#businessTable');
      });
    },
    destroy_business_table() {
      if ($.fn.DataTable.isDataTable('#businessTable')) {
        $('#businessTable').DataTable().destroy();
      }
    },
    handle_business_dashboard_card_click(card) {
      this.destroy_business_table();
      this.business_dashboard_filter = card.filter || 'all';
      this.refresh_business_table();
    },
    is_business_dashboard_card_active(card) {
      return this.business_dashboard_filter === (card.filter || 'all');
    },
    get_filtered_businesses(businesses) {
      const filters = {
        owners: business => Boolean(this.get_business_owner_id(business)),
        email: business => this.has_business_email(business),
        phone: business => this.has_business_phone(business),
      };
      const filter = filters[this.business_dashboard_filter];

      return filter ? businesses.filter(filter) : businesses;
    },
    get_business_owner_id(business) {
      const owner = business?.base_profile?.creater?.id;
      return owner;
    },
    has_business_email(business) {
      return Boolean(String(business?.email || '').trim());
    },
    has_business_phone(business) {
      return Boolean(String(business?.tell_number || business?.phone_number || '').trim());
    },
    fetch_businesses() {
      this.isLoading = true;
      return new Promise((resolve) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_all_company_profile/`,
          method: 'GET',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          success: (data) => {
            this.businesses = data.data || [];
            this.isLoading = false;
            this.refresh_business_table();
            resolve();
          },
          error: () => {
            this.businesses = [];
            resolve();
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      });
    },
  
    view_profile(profile){
        view_profile_helper(this.$router, profile);
      },
      delete_company_profile(profile_id) {
        Swal.fire({
          title: 'Are you sure?',
          text: 'This will permanently delete the company profile.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, delete it!',
          position: 'bottom-end',
          toast: true
        }).then((result) => {
          if (result.isConfirmed) {
            $.ajax({
              url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_user_company_profile/`,
              type: 'DELETE',
              headers: {
                Authorization: `Token ${get_token()}`,
                'Content-Type': 'application/json'
              },
              data: JSON.stringify({profile_id: profile_id}),
              success: (response) => {
                if (response.status === 'success') {
                  Swal.fire({
                    title: 'Deleted!',
                    text: response.message,
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'bottom-end',
                    toast: true
                  }).then(() => {
                    window.location.reload();
                  });
                }
              },
              error: (err) => {
                Swal.fire({
                  title: 'Error!',
                  text: err.responseJSON?.message || 'Something went wrong',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            });
          }
        });
      },
  },
  mounted() {
    this.user_details = get_user_details();
    this.fetch_businesses();
  },
  inject: ['client_features'],
};
